export enum ToastTypeKeys {
  STUDENT = 'student',
  EMPLOYEE = 'employee',
}
